import Positions from '@/app/positions'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { positionsQueryOptions } from '@/hooks/usePositionsQuery'
// import { ability } from '@/casl/ability'
// import { getFirstAccessibleRoute } from '@/constants/Auth'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <Positions />
}

export const Route = createFileRoute('/_auth/_withProject/positions')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Görevler')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    await queryClient.prefetchQuery(positionsQueryOptions)
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


